export default {"src":"/_next/static/media/reebelo_text_logo.4e7217a8.svg","height":24,"width":100};